<template>
<div v-show="isModalVisible">
<div class="modal-mask" @click="closeModal">
      <div class="modal-container" @click.stop>
      <!-- Modal Header -->
      <div class="modal-header">
        <h6 class="modal-title"></h6>
        <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
         <div id="payment_loader">
           <div class="form-group loader-msg" >
             Processing... Please Wait
           </div>
           <div class="form-group row">
             <img src="@/assets/pay-loading.gif"  width="400" height="300" alt="Processing Payment..." class="center">
           </div>
         </div>  
        <div class="form-group row" id="success_payment" style="display: none;">
        <div v-if="status == 'success'">
        <div class="form-group success-msg">
           Order Successful!
        </div>
        <img src="@/assets/green-tick.jpg"  width="100" height="120" alt="Success" class="center">
       
        <h6 class="modal-title" style="margin-top:10px;">Enter an Email to send Receipt</h6>
        <div v-show="submit_form_errors" class="validate-warning-msg-login">{{ submit_form_errors }}</div>
        <form @submit.prevent="onSubmit" class="p-2">
        <div class="form-group row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <input 
                type="text" 
                name="to_email"
                class="form-control"
                v-model="to_email"
                placeholder="Enter Email"
                maxLength="255"
                v-validate="'required'">
                <div v-if="verrors.firstByRule('to_email', 'required')" :class="'margin-bottom-5 validate-warning-msg ' + vmessage">Email is required</div>
            </div>
        </div>
        
        <div align="center">
            <button type="submit" class="btn btn-sm ma-blue-btn">Send</button>
        </div>
        </form>
        </div>
        <div v-else>
             <div class="form-group loader-msg" >
                The transaction is failed. Please check the credit card details entered.
             </div>
        </div>
        </div>
      </div>
     </div>

     

</div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import axios from 'axios';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  props: [
    'isModalVisible',
    'status',
    'orderId',
    'invoiceFilename'
    ],
  data() {
    return {
        loading: false,
        submit_form_errors: '',
        success_msg: '',
        email_subject: '',
        email_message: '',
        vmessage: '',
        first_name: '',
        last_name: '',
        modal_title: '',
        modal_type: '',
        to_email: '',
        isAdminEmailConfirmModalVisible: false,
    }
  },
  methods: {
    closeModal() {
      this.subject = '';
      this.message = '';
      this.vmessage = 'hide_vmessage';
      this.$validator.errors.clear();
      this.$emit('close');
      this.navigate();
    },
    getAdminDetail(user, vmsg) {
        this.vmessage = vmsg;
        this.first_name = user.admin_fname ? user.admin_fname : user.mentee_fname;
        this.last_name = user.admin_lname ? user.admin_lname : user.mentee_lname;
        this.to_email = user.admin_email ? user.admin_email : user.mentee_email;
    },
    resetPassword() {
        this.modal_title = "Are you sure you want to reset password for " + this.first_name + " " + this.last_name + "?";
        this.modal_type = "reset";
        this.isAdminEmailConfirmModalVisible = true;
    },
    onSubmit() {
      this.vmessage = "show_vmessage";
      this.$validator.validateAll().then((result) => {
          if(!result){
              return;
          }
          else {
              axios('/account_lookup_purchase/send_invoice',
                  {
                  method: 'POST',
                  data: {
                      emailAddress: this.to_email,
                      orderId: this.orderId,
                      invoiceFilename: this.invoiceFilename,
                  }
                  },
              )
              .then(response => {
                  this.flash({ message: 'Email sent successfully with Invoice', variant: 'success' });
                  this.navigate();
              })
              .catch(error => {

              })
          }
      }).catch(() => {
          // catches the error;
      });
    },
    
    navigate(){
        this.$router.push(this.$router.currentRoute.fullPath)
        this.$router.go();
    }
  },
  
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow-y: scroll;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 500px;
  height: auto;
  overflow-y: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modal-body {
  margin: 0px;
  padding: 10px;
}
.modal-header .sub-heading {
  background-color: #FFF;
  color: #555;
}
.modal-header {
  padding: 5px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.history-table-wrapper {
  height: 350px;
  overflow-y: auto;
}
.modal-footer {
  border-top: none;
}
.btn-danger {
  background-color: #00ACEE;
  border-color: #00ACEE;
}
.modal-title {
  color: #7d7d7d;
  font-size: 14px;
  font-weight: 900;
  margin-left: 10px;
}
.modal-header {
  border-bottom: 0px;
  margin-bottom: 10px;
}
.modal-body {
  padding: 5px;
}
.ma-blue-btn {
  color: #FFF !important; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  width: 150px;
}
.form-control { font-size: 14px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
.ma-reset-password-btn, .ma-reset-password-btn:focus, .ma-reset-password-btn:active, .ma-reset-password-btn:hover {
  color: #FFF !important;
  background: #00ACEE !important;
  border: 1px solid #00ACEE !important;
  min-height: 35px;
  margin-top: -5px;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.success-msg {
  text-align: center;
  font-size: 24px;
  width: 100%;
  color:  #228B22;
}
.loader-msg {
  text-align: center;
  font-size: 24px;
  width: 100%;
  color:  #555;
}

</style>


// WEBPACK FOOTER //
// src/components/admin/admin_purchase_confirm.vue